module.exports = __webpack_public_path__ + "assets/img/lp-invoice.7fe7c002.svg";